if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      constructor() {
        super();
        this.timeInHours = 60 * 60;
        this.closeButtons = this.querySelectorAll('.js-np-close');
        this.closePermanent = this.querySelector('[id^="NewsletterClosePermanent-"]');
        this.cookieTimeLimit = parseFloat(this.dataset.closePermanentThreshold);
        this.newsletterSubmit = this.querySelector('button[type="submit"]');
        this.newsletterForm = this.querySelector('form');
        this.handleClose = this.close.bind(this);
        this.cookieName = 'Velanto_newsletter_closed';
      }

      connectedCallback() {
        this.checkCookieExpiration();

        if (!this.getCookie(this.cookieName)) {
          requestAnimationFrame(()=>requestAnimationFrame(()=>setTimeout(() => {
            if (this.classList.contains('visually-hidden'))
              this.classList.remove('visually-hidden');
            this.open();
          }, 1000)));
        }

        this.closeButtons.forEach(button => button.addEventListener('click', this.handleClose));

        if (this.newsletterForm)
          this.newsletterForm.addEventListener('submit', (event) => this.onFormSubmit(event));
      }

      disconnectedCallback() {
        this.closeButtons.forEach(button => button.removeEventListener('click', this.handleClose));
      }

      open() {
        if (!this.hasAttribute('open')) this.setAttribute('open', '');
      }

      close() {
        if (this.closePermanent && this.closePermanent.checked) this.setCookie();
        if (this.closePermanent && !this.closePermanent.checked) this.setShortCookie();
        if (this.hasAttribute('open')) this.removeAttribute('open');
      }

      setShortCookie() {
        this.setCookie(2 * this.timeInHours);
      }

      setCookie(expirationSeconds = this.cookieTimeLimit * 24 * this.timeInHours) {
        const expirationDate = new Date(Date.now() + expirationSeconds * 1000).toUTCString();
        document.cookie = `${this.cookieName}=true; expires=${expirationDate}; path=/; domain=${document.domain || window.location.hostname}`;
      }

      setLongCookie() {
        this.setCookie(30 * 24 * this.timeInHours);
      }

      getCookie(name) {
        const cookies = document.cookie.split(';').map(cookie => cookie.trim());
        const cookie = cookies.find(cookie => cookie.startsWith(`${name}=`));
        return cookie ? cookie.split('=')[1] : null;
      }

      checkCookieExpiration() {
        const cookieValue = this.getCookie(this.cookieName);
        if (cookieValue === 'true') {
          const cookies = document.cookie.split(';').map(cookie => cookie.trim());
          const cookie = cookies.find(cookie => cookie.startsWith(`${this.cookieName}=`));
          if (cookie) {
            const expiration = cookie.split(';').find(part => part.trim().startsWith('expires='));
            if (expiration) {
              const expirationDate = new Date(expiration.split('=')[1]);
              if (expirationDate < new Date()) {
                document.cookie = `${this.cookieName}=false; path=/; domain=${document.domain || window.location.hostname}`;
              }
            }
          }
        }
      }

      async onFormSubmit(event) {
        if (this.newsletterSubmit.hasAttribute('aria-disabled')) return;
        this.newsletterSubmit.setAttribute('aria-disabled', true);

        setTimeout(() => {
          this.close();
          this.setCookie();

          setTimeout(() => {
            this.newsletterSubmit.removeAttribute('aria-disabled');
          }, 200);
        }, 1000);
      }
    }
  );
}